let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2GLNf")).then(() => parcelRequire('kGNsE'));